module.exports = __webpack_public_path__ + "img/add-employees.068f42ab.png";